import _ from 'lodash';
/**
 * Remove all undefined props from the object.
 */
export function omitUndefined(object) {
  return _.omitBy(object, _.isUndefined);
}